// extracted by mini-css-extract-plugin
module.exports = {"zoho_form_wrapper":"contactform_zoho_form_wrapper__xQoNr","style2":"contactform_style2__wFPpu"};